import { clearSessionStorage, setSessionStorage } from "./session.js"

export async function api(action, payload) {
  return call('api', action, payload)
}

async function call(namespace, action, payload) {
  const res = await fetch(`/${namespace}/${action}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload && JSON.stringify(payload),
  }).then(res => res.json())

  console.debug(`🟡 /${namespace}/${action}:`, payload, res)

  if (res.status === 'ok') {
    return res.data
  } else {
    if (res.errorCode === 'USER_NOT_LOGGED') {
      clearSessionStorage()
      let url = window.location.pathname + window.location.search
      setSessionStorage({ redirectAfterLogin: url })
      window.location.href = '/sign/up'
    } else {
      throw res
    }
  }
}

export async function requestPasswordReset(email) {
  return api('password_reset_request', { email })
}

export async function validateResetToken(token) {
  return api('password_reset_validate', { token })
}

export async function confirmPasswordReset(token, password) {
  return api('password_reset_confirm', { token, password })
}
